import React from 'react'
import PropTypes from 'prop-types'
import { Text, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'

import priceFormatter from '../../util/price-formatter'

/** = Styles */
const StrikeThroughBox = styled(Text.p)`
  position: relative;
  font-size: 12px;
  text-align: right;
  color: ${getPaletteColor('text.light')};
  margin-bottom: 2px;

  ${(props) => props.theme.flyQueries.tablet} {
    font-size: 14px;
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    text-align: center;
  }
`

const StrikePrice = styled(Text.span)`
  position: relative;

  &::before {
    content: '';
    width: 100%;
    position: absolute;
    right: 0;
    top: 48%;
    border-bottom: 1px solid ${getPaletteColor('text.light')};
    transform: ${(props) => (props.strikeThroughVariant ? 'skewY(-10deg)' : 'none')};
  }
`

/** = Component */
export default function StrikethroughPrice({ price, currencyCode, children }) {
  // Removed the Price rounded strikethrough since the test lost
  const { symbol, dollar } = priceFormatter({
    price: Math.ceil(price),
    currencyCode,
  })

  return (
    <StrikeThroughBox data-test='strike-through-price'>
      {children}
      <StrikePrice data-test='strike-price'>
        {symbol}
        {dollar}
      </StrikePrice>
    </StrikeThroughBox>
  )
}

StrikethroughPrice.defaultProps = {
  currencyCode: 'USD',
}

StrikethroughPrice.propTypes = {
  price: PropTypes.number.isRequired,
  currencyCode: PropTypes.string,
  children: PropTypes.node,
}

StrikethroughPrice.contextTypes = {
  SETI: PropTypes.object,
}
